import { buttonVariants } from 'design-system'

export const GetHelpButton = () => (
  <a
    href="https://support.yellowdig.co/"
    className={buttonVariants({ buttonType: 'link' })}
    target="_blank"
    rel="noopener noreferrer">
    Get Help
  </a>
)
